import { render, staticRenderFns } from "./ToolsBlock.vue?vue&type=template&id=088a5d17&"
import script from "./ToolsBlock.vue?vue&type=script&lang=js&"
export * from "./ToolsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports